<header>
  <h1>
    <a href="https://tsp-quantum.netlify.app/"
      ><img src="/img/TSPQ_Logo.svg" alt="TSP Quantum Logo" />
    </a>
  </h1>
</header>

<style>
  header {
    background: #f7f7f7;
    padding: 20px;
  }
  h1 {
    margin: 0;
    text-align: center;
  }
  img {
    max-width: 240px;
    transition: 0.25s ease-out;
  }
  img:hover, img:focus {
    transform: scale(1.1);
    opacity: 0.7;
  }
</style>
